import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { INITIAL_STATE, ResendAccessContext } from './resendAccessContext';

export const ResendAccessProvider = ({ children }) => {
  const [modalIsOpen, setModalIsOpen] = useState(INITIAL_STATE.modalIsOpen);
  const [bannerIsOpen, setBannerIsOpen] = useState(INITIAL_STATE.bannerIsOpen);
  const [sendLaterModalIsOpen, setSendLaterModalIsOpen] = useState(
    INITIAL_STATE.infoModalIsOpen
  );

  return (
    <ResendAccessContext.Provider
      value={{
        modalIsOpen,
        setModalIsOpen,
        bannerIsOpen,
        setBannerIsOpen,
        sendLaterModalIsOpen,
        setSendLaterModalIsOpen
      }}
    >
      {children}
    </ResendAccessContext.Provider>
  );
};

ResendAccessProvider.propTypes = {
  children: PropTypes.node
};
